import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';
import SvgError from '../../../../assets/svgs/error.svg';
import TextareaCompatible from 'react-textarea-compatible';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);

class TextareaPlaceholder extends PureComponent {
  render() {
    const {
      value = '',
      disabled,
      fullWidth,
      className,
      innerRef,
      errorText,
      maxLength,
      placeholder,
      style,
      onChange,
      ...props
    } = this.props;
    return (
      <>
        <div
          onChange={
            value.length <= maxLength
              ? onChange
              : onChange({ target: { value: value.slice(0, maxLength) } })
          }
          {...props}
          ref={innerRef}
        >
          <TextareaCompatible
            value={value}
            className={cx('Textarea', { disabled, fullWidth, errorText }, className)}
            disabled={disabled}
            maxLength={maxLength}
            placeholder={placeholder}
            style={style}
          />
        </div>
        <div className={cx('options')}>
          {errorText && (
            <div className={cx('error-text')}>
              <SvgError />
              {errorText}
            </div>
          )}
          {maxLength && (
            <>
              <div></div>
              <div className={cx('max-length')}>
                {value.length || 0}/{maxLength}
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

TextareaPlaceholder.propTypes = {
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
};

export default React.forwardRef((props, ref) => <TextareaPlaceholder innerRef={ref} {...props} />);
